// source: proto/entity/userIdentity.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var proto_common_crudFields_pb = require('../../proto/common/crudFields_pb.js');
goog.object.extend(proto, proto_common_crudFields_pb);
var proto_common_objectID_pb = require('../../proto/common/objectID_pb.js');
goog.object.extend(proto, proto_common_objectID_pb);
var proto_entity_user_pb = require('../../proto/entity/user_pb.js');
goog.object.extend(proto, proto_entity_user_pb);
goog.exportSymbol('proto.entity.UserIdentity', null, global);
goog.exportSymbol('proto.entity.UserIdentityDetails', null, global);
goog.exportSymbol('proto.entity.UserIdentityDetails.Auth0Details', null, global);
goog.exportSymbol('proto.entity.UserIdentityDetails.BigCommerceDetails', null, global);
goog.exportSymbol('proto.entity.UserIdentityDetails.GoogleDetails', null, global);
goog.exportSymbol('proto.entity.UserIdentityDetails.ShopifyDetails', null, global);
goog.exportSymbol('proto.entity.UserIdentityDetails.TypeCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UserIdentity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UserIdentity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UserIdentity.displayName = 'proto.entity.UserIdentity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UserIdentityDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.entity.UserIdentityDetails.oneofGroups_);
};
goog.inherits(proto.entity.UserIdentityDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UserIdentityDetails.displayName = 'proto.entity.UserIdentityDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UserIdentityDetails.Auth0Details = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UserIdentityDetails.Auth0Details, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UserIdentityDetails.Auth0Details.displayName = 'proto.entity.UserIdentityDetails.Auth0Details';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UserIdentityDetails.ShopifyDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UserIdentityDetails.ShopifyDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UserIdentityDetails.ShopifyDetails.displayName = 'proto.entity.UserIdentityDetails.ShopifyDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UserIdentityDetails.BigCommerceDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UserIdentityDetails.BigCommerceDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UserIdentityDetails.BigCommerceDetails.displayName = 'proto.entity.UserIdentityDetails.BigCommerceDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UserIdentityDetails.GoogleDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UserIdentityDetails.GoogleDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UserIdentityDetails.GoogleDetails.displayName = 'proto.entity.UserIdentityDetails.GoogleDetails';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UserIdentity.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UserIdentity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UserIdentity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UserIdentity.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: (f = msg.getUserId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    provider: jspb.Message.getFieldWithDefault(msg, 3, ""),
    providerId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    details: (f = msg.getDetails()) && proto.entity.UserIdentityDetails.toObject(includeInstance, f),
    crudFields: (f = msg.getCrudFields()) && proto_common_crudFields_pb.CRUDFields.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UserIdentity}
 */
proto.entity.UserIdentity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UserIdentity;
  return proto.entity.UserIdentity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UserIdentity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UserIdentity}
 */
proto.entity.UserIdentity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProvider(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setProviderId(value);
      break;
    case 5:
      var value = new proto.entity.UserIdentityDetails;
      reader.readMessage(value,proto.entity.UserIdentityDetails.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    case 6:
      var value = new proto_common_crudFields_pb.CRUDFields;
      reader.readMessage(value,proto_common_crudFields_pb.CRUDFields.deserializeBinaryFromReader);
      msg.setCrudFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UserIdentity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UserIdentity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UserIdentity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UserIdentity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProvider();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProviderId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.entity.UserIdentityDetails.serializeBinaryToWriter
    );
  }
  f = message.getCrudFields();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto_common_crudFields_pb.CRUDFields.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.ObjectID user_id = 1;
 * @return {?proto.common.ObjectID}
 */
proto.entity.UserIdentity.prototype.getUserId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.UserIdentity} returns this
*/
proto.entity.UserIdentity.prototype.setUserId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UserIdentity} returns this
 */
proto.entity.UserIdentity.prototype.clearUserId = function() {
  return this.setUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UserIdentity.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.entity.UserIdentity.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.UserIdentity} returns this
 */
proto.entity.UserIdentity.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string provider = 3;
 * @return {string}
 */
proto.entity.UserIdentity.prototype.getProvider = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.UserIdentity} returns this
 */
proto.entity.UserIdentity.prototype.setProvider = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string provider_id = 4;
 * @return {string}
 */
proto.entity.UserIdentity.prototype.getProviderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.UserIdentity} returns this
 */
proto.entity.UserIdentity.prototype.setProviderId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional UserIdentityDetails details = 5;
 * @return {?proto.entity.UserIdentityDetails}
 */
proto.entity.UserIdentity.prototype.getDetails = function() {
  return /** @type{?proto.entity.UserIdentityDetails} */ (
    jspb.Message.getWrapperField(this, proto.entity.UserIdentityDetails, 5));
};


/**
 * @param {?proto.entity.UserIdentityDetails|undefined} value
 * @return {!proto.entity.UserIdentity} returns this
*/
proto.entity.UserIdentity.prototype.setDetails = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UserIdentity} returns this
 */
proto.entity.UserIdentity.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UserIdentity.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional common.CRUDFields crud_fields = 6;
 * @return {?proto.common.CRUDFields}
 */
proto.entity.UserIdentity.prototype.getCrudFields = function() {
  return /** @type{?proto.common.CRUDFields} */ (
    jspb.Message.getWrapperField(this, proto_common_crudFields_pb.CRUDFields, 6));
};


/**
 * @param {?proto.common.CRUDFields|undefined} value
 * @return {!proto.entity.UserIdentity} returns this
*/
proto.entity.UserIdentity.prototype.setCrudFields = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UserIdentity} returns this
 */
proto.entity.UserIdentity.prototype.clearCrudFields = function() {
  return this.setCrudFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UserIdentity.prototype.hasCrudFields = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.entity.UserIdentityDetails.oneofGroups_ = [[2,3,4,5]];

/**
 * @enum {number}
 */
proto.entity.UserIdentityDetails.TypeCase = {
  TYPE_NOT_SET: 0,
  AUTH0_DETAILS: 2,
  SHOPIFY_DETAILS: 3,
  BIG_COMMERCE_DETAILS: 4,
  GOOGLE_DETAILS: 5
};

/**
 * @return {proto.entity.UserIdentityDetails.TypeCase}
 */
proto.entity.UserIdentityDetails.prototype.getTypeCase = function() {
  return /** @type {proto.entity.UserIdentityDetails.TypeCase} */(jspb.Message.computeOneofCase(this, proto.entity.UserIdentityDetails.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UserIdentityDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UserIdentityDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UserIdentityDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UserIdentityDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    userProfile: (f = msg.getUserProfile()) && proto_entity_user_pb.UserProfile.toObject(includeInstance, f),
    auth0Details: (f = msg.getAuth0Details()) && proto.entity.UserIdentityDetails.Auth0Details.toObject(includeInstance, f),
    shopifyDetails: (f = msg.getShopifyDetails()) && proto.entity.UserIdentityDetails.ShopifyDetails.toObject(includeInstance, f),
    bigCommerceDetails: (f = msg.getBigCommerceDetails()) && proto.entity.UserIdentityDetails.BigCommerceDetails.toObject(includeInstance, f),
    googleDetails: (f = msg.getGoogleDetails()) && proto.entity.UserIdentityDetails.GoogleDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UserIdentityDetails}
 */
proto.entity.UserIdentityDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UserIdentityDetails;
  return proto.entity.UserIdentityDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UserIdentityDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UserIdentityDetails}
 */
proto.entity.UserIdentityDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_user_pb.UserProfile;
      reader.readMessage(value,proto_entity_user_pb.UserProfile.deserializeBinaryFromReader);
      msg.setUserProfile(value);
      break;
    case 2:
      var value = new proto.entity.UserIdentityDetails.Auth0Details;
      reader.readMessage(value,proto.entity.UserIdentityDetails.Auth0Details.deserializeBinaryFromReader);
      msg.setAuth0Details(value);
      break;
    case 3:
      var value = new proto.entity.UserIdentityDetails.ShopifyDetails;
      reader.readMessage(value,proto.entity.UserIdentityDetails.ShopifyDetails.deserializeBinaryFromReader);
      msg.setShopifyDetails(value);
      break;
    case 4:
      var value = new proto.entity.UserIdentityDetails.BigCommerceDetails;
      reader.readMessage(value,proto.entity.UserIdentityDetails.BigCommerceDetails.deserializeBinaryFromReader);
      msg.setBigCommerceDetails(value);
      break;
    case 5:
      var value = new proto.entity.UserIdentityDetails.GoogleDetails;
      reader.readMessage(value,proto.entity.UserIdentityDetails.GoogleDetails.deserializeBinaryFromReader);
      msg.setGoogleDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UserIdentityDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UserIdentityDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UserIdentityDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UserIdentityDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserProfile();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_user_pb.UserProfile.serializeBinaryToWriter
    );
  }
  f = message.getAuth0Details();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.entity.UserIdentityDetails.Auth0Details.serializeBinaryToWriter
    );
  }
  f = message.getShopifyDetails();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.entity.UserIdentityDetails.ShopifyDetails.serializeBinaryToWriter
    );
  }
  f = message.getBigCommerceDetails();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.entity.UserIdentityDetails.BigCommerceDetails.serializeBinaryToWriter
    );
  }
  f = message.getGoogleDetails();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.entity.UserIdentityDetails.GoogleDetails.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UserIdentityDetails.Auth0Details.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UserIdentityDetails.Auth0Details.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UserIdentityDetails.Auth0Details} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UserIdentityDetails.Auth0Details.toObject = function(includeInstance, msg) {
  var f, obj = {
    connection: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UserIdentityDetails.Auth0Details}
 */
proto.entity.UserIdentityDetails.Auth0Details.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UserIdentityDetails.Auth0Details;
  return proto.entity.UserIdentityDetails.Auth0Details.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UserIdentityDetails.Auth0Details} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UserIdentityDetails.Auth0Details}
 */
proto.entity.UserIdentityDetails.Auth0Details.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConnection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UserIdentityDetails.Auth0Details.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UserIdentityDetails.Auth0Details.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UserIdentityDetails.Auth0Details} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UserIdentityDetails.Auth0Details.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConnection();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string connection = 1;
 * @return {string}
 */
proto.entity.UserIdentityDetails.Auth0Details.prototype.getConnection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.UserIdentityDetails.Auth0Details} returns this
 */
proto.entity.UserIdentityDetails.Auth0Details.prototype.setConnection = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UserIdentityDetails.ShopifyDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UserIdentityDetails.ShopifyDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UserIdentityDetails.ShopifyDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UserIdentityDetails.ShopifyDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    shop: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UserIdentityDetails.ShopifyDetails}
 */
proto.entity.UserIdentityDetails.ShopifyDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UserIdentityDetails.ShopifyDetails;
  return proto.entity.UserIdentityDetails.ShopifyDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UserIdentityDetails.ShopifyDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UserIdentityDetails.ShopifyDetails}
 */
proto.entity.UserIdentityDetails.ShopifyDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setShop(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UserIdentityDetails.ShopifyDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UserIdentityDetails.ShopifyDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UserIdentityDetails.ShopifyDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UserIdentityDetails.ShopifyDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShop();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional string shop = 1;
 * @return {string}
 */
proto.entity.UserIdentityDetails.ShopifyDetails.prototype.getShop = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.UserIdentityDetails.ShopifyDetails} returns this
 */
proto.entity.UserIdentityDetails.ShopifyDetails.prototype.setShop = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 user_id = 2;
 * @return {number}
 */
proto.entity.UserIdentityDetails.ShopifyDetails.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.UserIdentityDetails.ShopifyDetails} returns this
 */
proto.entity.UserIdentityDetails.ShopifyDetails.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UserIdentityDetails.BigCommerceDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UserIdentityDetails.BigCommerceDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UserIdentityDetails.BigCommerceDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UserIdentityDetails.BigCommerceDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    storeHash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UserIdentityDetails.BigCommerceDetails}
 */
proto.entity.UserIdentityDetails.BigCommerceDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UserIdentityDetails.BigCommerceDetails;
  return proto.entity.UserIdentityDetails.BigCommerceDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UserIdentityDetails.BigCommerceDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UserIdentityDetails.BigCommerceDetails}
 */
proto.entity.UserIdentityDetails.BigCommerceDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStoreHash(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UserIdentityDetails.BigCommerceDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UserIdentityDetails.BigCommerceDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UserIdentityDetails.BigCommerceDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UserIdentityDetails.BigCommerceDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStoreHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string store_hash = 1;
 * @return {string}
 */
proto.entity.UserIdentityDetails.BigCommerceDetails.prototype.getStoreHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.UserIdentityDetails.BigCommerceDetails} returns this
 */
proto.entity.UserIdentityDetails.BigCommerceDetails.prototype.setStoreHash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 user_id = 2;
 * @return {number}
 */
proto.entity.UserIdentityDetails.BigCommerceDetails.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.UserIdentityDetails.BigCommerceDetails} returns this
 */
proto.entity.UserIdentityDetails.BigCommerceDetails.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UserIdentityDetails.GoogleDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UserIdentityDetails.GoogleDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UserIdentityDetails.GoogleDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UserIdentityDetails.GoogleDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    resourceName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UserIdentityDetails.GoogleDetails}
 */
proto.entity.UserIdentityDetails.GoogleDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UserIdentityDetails.GoogleDetails;
  return proto.entity.UserIdentityDetails.GoogleDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UserIdentityDetails.GoogleDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UserIdentityDetails.GoogleDetails}
 */
proto.entity.UserIdentityDetails.GoogleDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setResourceName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UserIdentityDetails.GoogleDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UserIdentityDetails.GoogleDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UserIdentityDetails.GoogleDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UserIdentityDetails.GoogleDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResourceName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string resource_name = 1;
 * @return {string}
 */
proto.entity.UserIdentityDetails.GoogleDetails.prototype.getResourceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.UserIdentityDetails.GoogleDetails} returns this
 */
proto.entity.UserIdentityDetails.GoogleDetails.prototype.setResourceName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional UserProfile user_profile = 1;
 * @return {?proto.entity.UserProfile}
 */
proto.entity.UserIdentityDetails.prototype.getUserProfile = function() {
  return /** @type{?proto.entity.UserProfile} */ (
    jspb.Message.getWrapperField(this, proto_entity_user_pb.UserProfile, 1));
};


/**
 * @param {?proto.entity.UserProfile|undefined} value
 * @return {!proto.entity.UserIdentityDetails} returns this
*/
proto.entity.UserIdentityDetails.prototype.setUserProfile = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UserIdentityDetails} returns this
 */
proto.entity.UserIdentityDetails.prototype.clearUserProfile = function() {
  return this.setUserProfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UserIdentityDetails.prototype.hasUserProfile = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Auth0Details auth0_details = 2;
 * @return {?proto.entity.UserIdentityDetails.Auth0Details}
 */
proto.entity.UserIdentityDetails.prototype.getAuth0Details = function() {
  return /** @type{?proto.entity.UserIdentityDetails.Auth0Details} */ (
    jspb.Message.getWrapperField(this, proto.entity.UserIdentityDetails.Auth0Details, 2));
};


/**
 * @param {?proto.entity.UserIdentityDetails.Auth0Details|undefined} value
 * @return {!proto.entity.UserIdentityDetails} returns this
*/
proto.entity.UserIdentityDetails.prototype.setAuth0Details = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.entity.UserIdentityDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UserIdentityDetails} returns this
 */
proto.entity.UserIdentityDetails.prototype.clearAuth0Details = function() {
  return this.setAuth0Details(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UserIdentityDetails.prototype.hasAuth0Details = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ShopifyDetails shopify_details = 3;
 * @return {?proto.entity.UserIdentityDetails.ShopifyDetails}
 */
proto.entity.UserIdentityDetails.prototype.getShopifyDetails = function() {
  return /** @type{?proto.entity.UserIdentityDetails.ShopifyDetails} */ (
    jspb.Message.getWrapperField(this, proto.entity.UserIdentityDetails.ShopifyDetails, 3));
};


/**
 * @param {?proto.entity.UserIdentityDetails.ShopifyDetails|undefined} value
 * @return {!proto.entity.UserIdentityDetails} returns this
*/
proto.entity.UserIdentityDetails.prototype.setShopifyDetails = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.entity.UserIdentityDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UserIdentityDetails} returns this
 */
proto.entity.UserIdentityDetails.prototype.clearShopifyDetails = function() {
  return this.setShopifyDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UserIdentityDetails.prototype.hasShopifyDetails = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional BigCommerceDetails big_commerce_details = 4;
 * @return {?proto.entity.UserIdentityDetails.BigCommerceDetails}
 */
proto.entity.UserIdentityDetails.prototype.getBigCommerceDetails = function() {
  return /** @type{?proto.entity.UserIdentityDetails.BigCommerceDetails} */ (
    jspb.Message.getWrapperField(this, proto.entity.UserIdentityDetails.BigCommerceDetails, 4));
};


/**
 * @param {?proto.entity.UserIdentityDetails.BigCommerceDetails|undefined} value
 * @return {!proto.entity.UserIdentityDetails} returns this
*/
proto.entity.UserIdentityDetails.prototype.setBigCommerceDetails = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.entity.UserIdentityDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UserIdentityDetails} returns this
 */
proto.entity.UserIdentityDetails.prototype.clearBigCommerceDetails = function() {
  return this.setBigCommerceDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UserIdentityDetails.prototype.hasBigCommerceDetails = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional GoogleDetails google_details = 5;
 * @return {?proto.entity.UserIdentityDetails.GoogleDetails}
 */
proto.entity.UserIdentityDetails.prototype.getGoogleDetails = function() {
  return /** @type{?proto.entity.UserIdentityDetails.GoogleDetails} */ (
    jspb.Message.getWrapperField(this, proto.entity.UserIdentityDetails.GoogleDetails, 5));
};


/**
 * @param {?proto.entity.UserIdentityDetails.GoogleDetails|undefined} value
 * @return {!proto.entity.UserIdentityDetails} returns this
*/
proto.entity.UserIdentityDetails.prototype.setGoogleDetails = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.entity.UserIdentityDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UserIdentityDetails} returns this
 */
proto.entity.UserIdentityDetails.prototype.clearGoogleDetails = function() {
  return this.setGoogleDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UserIdentityDetails.prototype.hasGoogleDetails = function() {
  return jspb.Message.getField(this, 5) != null;
};


goog.object.extend(exports, proto.entity);
